var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _path, _g31, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlan3({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 327.242,
    height: 244.76,
    viewBox: "0 0 327.242 244.76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2219",
    "data-name": "Path 2219",
    d: "M321.9,208.913a133.756,133.756,0,0,1-18.321,68.264v.007c-10.7,18.995-21.373,40.487-38.216,49.567-101.089,13.66-111.436,4.071-141.608-46.774a133.471,133.471,0,0,1-20.031-71.064C106.16,47.2,319.47,47.169,321.9,208.913Z",
    transform: "translate(-103.723 -87.617)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_583",
    "data-name": "Path 583",
    d: "M1441.774,695.54s-8.384,1.175-14.243,1.337-20.857-42.889,5.022-41.133S1454.318,686.756,1441.774,695.54Z",
    transform: "translate(-1417.867 -655.691)",
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3249",
    "data-name": "Group 3249",
    transform: "translate(-1004.879 -4155.899)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_984",
    "data-name": "Group 984",
    transform: "translate(1004.879 4208.166)",
    opacity: 0.46
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2224",
    "data-name": "Path 2224",
    d: "M202.467,168.491s-1.632,38.717-8.818,37.969,4.928-43.013,4.928-43.013-30.626-24.591-44.459-26.423c0,0,12.972,41.19,6.193,38.7s-22.271-44.73-22.271-44.73-33.831-14.756-44.369,4.875S89.866,168.1,94.8,170.624s38.64,9.893,36.754,14.055-26.2,5.874-37.948-.993c0,0,5.959,37.721,24.7,40.233s27.044-7.519,38.592-5.757,19.134,6.742,12.75,8.48-25.109-4.776-36.083.887-19.508,8.742-3.3,16.185,47.266,12.358,56.417.683l1.145-1.46a7.087,7.087,0,0,1-1.145,1.46c2.714,2.562,5.4,12.39,7.106,19.85.2,1.248.572,3,1.169,5.4h0c.219,1.072.389,1.946.506,2.558,2.514,16.4-6.686,41.589-6.686,41.589l3.409,1.822c14.126-24.255,4.975-49,4.975-49-5.211-19.149-1.329-33.886-1.329-33.886s36.988-10.729,27.491-39.152C223.321,193.571,214.647,175.458,202.467,168.491Z",
    transform: "translate(-88.092 -125.668)",
    fill: "#dfeafd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2225",
    "data-name": "Path 2225",
    d: "M408.016,157.16c-1.04-21.814-37.2-23.032-37.2-23.032s-31.523,30.83-38.574,30.178,21.805-31.624,21.805-31.624c-13.013-4.215-50.485,4.621-50.485,4.621s-7.113,42.5-13.786,40.133S298,140.124,298,140.124c-13.717,1.025-29.033,13.392-29.033,13.392-20.4,21.141,7.8,46.238,7.8,46.238s-2.783,14.677-15.473,29.42h0a50.863,50.863,0,0,0-5.935,7.434l3.508.774q.741-1.318,1.551-2.514l.011-.015.024-.033c.359-.49.874-1.185,1.511-2.03l0,0,0,0c1.534-1.863,2.6-3.253,3.3-4.271l.006-.009c4.662-5.879,11.178-13.44,14.66-14.56a7,7,0,0,1-.4-1.775c.126.566.259,1.156.4,1.775,3.17,14.189,32.72,22.946,50.2,23.2s11.231-6.07,3.911-15.711-26.636-11.778-31.551-16.009,3.9-5.438,14.858-2.124,14.082,15.692,31.718,21.376S387.9,199.5,387.9,199.5c-13.288,1.121-34.078-10.653-33.991-15.131s33.016,3.224,38.446,3.072S409.057,178.975,408.016,157.16Z",
    transform: "translate(-80.841 -122.61)",
    fill: "#b2cbfd",
    opacity: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_980",
    "data-name": "Group 980",
    transform: "translate(1066.27 4155.9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_979",
    "data-name": "Group 979",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_978",
    "data-name": "Group 978",
    transform: "translate(-4.109 10.815)"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_740",
    "data-name": "Group 740",
    transform: "translate(0 199.41)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_728",
    "data-name": "Group 728",
    transform: "translate(135.238 266.631)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_721",
    "data-name": "Group 721"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_720",
    "data-name": "Group 720"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_719",
    "data-name": "Group 719"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2100",
    "data-name": "Path 2100",
    d: "M290.578,666.879l-.077.884L288.746,689.1l-1.6,19.541-20.363,1.018-4.155-35.3-.039-.308-.774-6.576Z",
    transform: "translate(-261.814 -666.879)",
    fill: "#ff6b4a"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_724",
    "data-name": "Group 724",
    transform: "translate(0.465 0.884)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_723",
    "data-name": "Group 723"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_722",
    "data-name": "Group 722"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2101",
    "data-name": "Path 2101",
    d: "M290.614,667.94l-1.755,21.335a1.728,1.728,0,0,1-.374.013c-4.813-.388-22.983-12.844-25.744-14.76l-.349-.241.309-.067Z",
    transform: "translate(-262.393 -667.94)",
    fill: "#d14222"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_727",
    "data-name": "Group 727",
    transform: "translate(0.723 36.199)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_726",
    "data-name": "Group 726"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_725",
    "data-name": "Group 725"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2102",
    "data-name": "Path 2102",
    d: "M265.728,716.643q-.614,5.752-1.383,11.719-.767,5.941-1.632,11.636l32.359-.589-4.8-22.257a15.617,15.617,0,0,0-9.817-6.622A15.363,15.363,0,0,0,265.728,716.643Z",
    transform: "translate(-262.714 -710.314)",
    fill: "#ff6b4a"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_734",
    "data-name": "Group 734",
    transform: "translate(0 259.734)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_731",
    "data-name": "Group 731",
    transform: "translate(18.466)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_730",
    "data-name": "Group 730"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_729",
    "data-name": "Group 729"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2103",
    "data-name": "Path 2103",
    d: "M168.605,660.291l-3.1,20.464-4.129,27.255c-3.781,2.773-21.589,15.429-32.249,15.2a16.317,16.317,0,0,1-11.227-4.446c-.516.067-1.02.148-1.51.214q9.484-4.439,18.956-8.852l.8-14.947,1.975-36.577Z",
    transform: "translate(-116.394 -658.603)",
    fill: "#ff6b4a"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_733",
    "data-name": "Group 733",
    transform: "translate(0 48.872)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_732",
    "data-name": "Group 732"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2104",
    "data-name": "Path 2104",
    d: "M157.894,739.664l-63.581,1.38s-6.968-8.639,17.55-12.3c.49-.067.993-.147,1.51-.214A16.317,16.317,0,0,0,124.6,732.98c10.659.228,28.467-12.429,32.249-15.2.464-.348.71-.535.71-.535Z",
    transform: "translate(-93.398 -717.244)",
    fill: "#ffc456"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_737",
    "data-name": "Group 737",
    transform: "translate(30.66)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_736",
    "data-name": "Group 736"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_735",
    "data-name": "Group 735"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2105",
    "data-name": "Path 2105",
    d: "M274.82,622.583q-25.168.654-50.327,1.339L209.007,398.917,176.746,619.9c-13.035-1.154-32.144-2.866-45.166-4.018,0,0,26.558-240.742,47.746-267.863a132.138,132.138,0,0,0,69.827-1.072C266.5,420.222,274.831,530.27,274.82,622.583Z",
    transform: "translate(-131.58 -346.951)",
    fill: "#422e32"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_739",
    "data-name": "Group 739",
    transform: "translate(132.554 303.352)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_738",
    "data-name": "Group 738"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2106",
    "data-name": "Path 2106",
    d: "M290.835,716.651c-.747-2.388-2.318-3.769-3.9-5.711.255.314-.438,1.867-.361,2.314.176,1.024.228.653.789,1.388a9.006,9.006,0,0,1,2.041,3.435c.629,2.291,2.438,9.9.4,11.527-1.069.85-4.2.808-5.487,1.008-5.179.8-11.081,1.7-16.187.066-5.773-1.844-2.852-9.753-2.117-13.8.462-2.534-1.4-4.838-2.122-1.486q-.4,1.831-.8,3.661-.776,3.546-1.553,7.093c-.255,1.164-3.055,13.958-3.056,13.957a83.931,83.931,0,0,0,38.748-.059c-2.113-7.668-4.241-15.329-6.277-23.019C290.909,716.9,290.873,716.773,290.835,716.651Z",
    transform: "translate(-258.472 -710.94)",
    fill: "#ffc456"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_742",
    "data-name": "Group 742",
    transform: "translate(75.389 170.605)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_741",
    "data-name": "Group 741"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2107",
    "data-name": "Path 2107",
    d: "M187.282,317.61l7.225,20.074-3.871,12.054,69.616-4.466.116-32.884Z",
    transform: "translate(-187.282 -312.388)",
    fill: "#ff6b4a"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_778",
    "data-name": "Group 778",
    transform: "translate(44.701 60.63)"
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_745",
    "data-name": "Group 745",
    transform: "translate(42.069 24.871)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_744",
    "data-name": "Group 744"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_743",
    "data-name": "Group 743"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2108",
    "data-name": "Path 2108",
    d: "M251.5,217.036c-.05,23.852-62.33,19.652-47.863-6.763a40.691,40.691,0,0,1,12.814,2.009,286.924,286.924,0,0,1,34.145.482A10.659,10.659,0,0,1,251.5,217.036Z",
    transform: "translate(-201.456 -210.273)",
    fill: "#ff6b4a"
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_748",
    "data-name": "Group 748",
    transform: "translate(4.361 24.947)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_747",
    "data-name": "Group 747"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_746",
    "data-name": "Group 746"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2109",
    "data-name": "Path 2109",
    d: "M262.894,251.079s-2.6,89.854-10.344,101.333-76.123,7.175-73.542,0-7.735-85.549-7.735-85.549L154.5,251.079c10.332-41.071,33.472-44.13,52.7-38.645C248.3,209.582,300.485,218.139,262.894,251.079Z",
    transform: "translate(-154.497 -210.364)",
    fill: "#f35d5d"
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_749",
    "data-name": "Group 749",
    transform: "translate(74.769 14.229)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2110",
    "data-name": "Path 2110",
    d: "M299.657,259.317c-.01,13.43-1.922,49.924-5.211,64.081-2.188,8.168-8.37,16.277-11.451,20.651l-.418,15.993s-3.75,6.485-21.657,7.352-18.742-3.459-18.742-3.459L246.755,252.4s8.335-17.718,10.832-22.478,2.08-9.508.835-16.859l-8.753-3.884-.41-11.676L263,207.446l2.088,3.459s15.41,3.892,17.489,6.917S299.657,243.757,299.657,259.317Z",
    transform: "translate(-242.178 -197.503)",
    fill: "#ffc456"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_755",
    "data-name": "Group 755",
    transform: "translate(55.979)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_752",
    "data-name": "Group 752"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_751",
    "data-name": "Group 751"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_750",
    "data-name": "Group 750"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2111",
    "data-name": "Path 2111",
    d: "M247.167,180.43l-.219,2.318-3.652,39.2H218.778c.308-6.337,1-20.585,1.29-26.786Z",
    transform: "translate(-218.778 -180.43)",
    fill: "#ffb27d"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_754",
    "data-name": "Group 754",
    transform: "translate(0.8)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_753",
    "data-name": "Group 753"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2112",
    "data-name": "Path 2112",
    d: "M247.364,180.43c-2.547,11.784-15.019,33.821-27.59,24.992l.491-10.259Z",
    transform: "translate(-219.774 -180.43)",
    fill: "#f1765a"
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_758",
    "data-name": "Group 758",
    transform: "translate(51.141 25.545)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_757",
    "data-name": "Group 757"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_756",
    "data-name": "Group 756"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2113",
    "data-name": "Path 2113",
    d: "M249.113,217.645c-.9,24.329-45.443,17.742-34.684-6.564a22.961,22.961,0,0,1,9.286,1.949,155.494,155.494,0,0,1,24.744.468A13.388,13.388,0,0,1,249.113,217.645Z",
    transform: "translate(-212.753 -211.081)",
    fill: "#ffb27d"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_760",
    "data-name": "Group 760",
    transform: "translate(84.148 22.269)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_759",
    "data-name": "Group 759"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2114",
    "data-name": "Path 2114",
    d: "M254.62,245.378l-.762-.263c2.233-6.981,4.115-10.238,6.5-11.245,2.432-1.028,5.158.432,8.929,2.454,1.816.974,3.858,2.069,6.255,3.107-.234-10.891-5.779-21.369-10.682-30.634l-.658-1.246.7-.4.658,1.245c5.044,9.53,10.759,20.331,10.788,31.66l0,.619-.553-.232c-2.675-1.123-4.91-2.32-6.882-3.378-3.581-1.92-6.168-3.306-8.258-2.423C258.548,235.533,256.742,238.745,254.62,245.378Z",
    transform: "translate(-253.858 -207.15)",
    fill: "#ffc456"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_762",
    "data-name": "Group 762",
    transform: "translate(81.321 111.682)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_761",
    "data-name": "Group 761"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2115",
    "data-name": "Path 2115",
    d: "M299.586,314.559c-1.2,20.459-3.374,35-14.069,47.738-18.445-4.78-9.348-23.049-19.673-32.662-3.823-2.8-13.387-3.366-15.169-8.533-2.08-6.01,6.039-3.334,8.5-3.1C272.743,319.285,286.035,313.539,299.586,314.559Z",
    transform: "translate(-250.338 -314.437)",
    fill: "#ffc456"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_764",
    "data-name": "Group 764",
    transform: "translate(81.076 72.451)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_763",
    "data-name": "Group 763"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2116",
    "data-name": "Path 2116",
    d: "M255.431,270.089c.051,3.635-5.451,3.635-5.4,0C249.982,266.455,255.483,266.455,255.431,270.089Z",
    transform: "translate(-250.033 -267.363)",
    fill: "#ffc456"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_766",
    "data-name": "Group 766",
    transform: "translate(79.849 92.062)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_765",
    "data-name": "Group 765"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2117",
    "data-name": "Path 2117",
    d: "M253.9,293.62c.051,3.635-5.451,3.635-5.4,0C248.454,289.986,253.955,289.986,253.9,293.62Z",
    transform: "translate(-248.505 -290.894)",
    fill: "#ffc456"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_768",
    "data-name": "Group 768",
    transform: "translate(78.867 109.38)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_767",
    "data-name": "Group 767"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2118",
    "data-name": "Path 2118",
    d: "M252.68,314.4c.051,3.634-5.45,3.634-5.4,0C247.231,310.766,252.733,310.766,252.68,314.4Z",
    transform: "translate(-247.282 -311.674)",
    fill: "#ffc456"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_770",
    "data-name": "Group 770",
    transform: "translate(79.113 128.227)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Group_769",
    "data-name": "Group 769"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2119",
    "data-name": "Path 2119",
    d: "M252.986,337.015c.051,3.634-5.45,3.634-5.4,0C247.537,333.38,253.038,333.38,252.986,337.015Z",
    transform: "translate(-247.588 -334.288)",
    fill: "#ffc456"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_772",
    "data-name": "Group 772",
    transform: "translate(78.377 148.093)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Group_771",
    "data-name": "Group 771"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2120",
    "data-name": "Path 2120",
    d: "M252.069,360.851c.051,3.635-5.45,3.635-5.4,0C246.62,357.217,252.122,357.217,252.069,360.851Z",
    transform: "translate(-246.671 -358.125)",
    fill: "#ffc456"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_774",
    "data-name": "Group 774",
    transform: "translate(78.377 164.902)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Group_773",
    "data-name": "Group 773"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2121",
    "data-name": "Path 2121",
    d: "M252.069,381.021c.051,3.634-5.45,3.634-5.4,0C246.62,377.386,252.122,377.386,252.069,381.021Z",
    transform: "translate(-246.671 -378.294)",
    fill: "#ffc456"
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Group_775",
    "data-name": "Group 775",
    transform: "translate(0 17.687)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2122",
    "data-name": "Path 2122",
    d: "M200.864,226l1.074-13.025a3.363,3.363,0,0,1,3.861-3.119h0c.08-1.567.153-3.1.217-4.551l.177-3.65-3.413,1.15,0,0c-6.4,1.877-13.131,4.09-20.114,6.706q-6.814,2.551-13.038,5.247c-7.227,8.736-19.646,21.069-20.56,38.835,1.666,8.646,24.308,13.039,23.476,20.388S161.3,358.709,161.3,358.709l38.735,4.323L212.943,252.8Z",
    transform: "translate(-149.066 -201.652)",
    fill: "#ffc456"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_777",
    "data-name": "Group 777",
    transform: "translate(34.764 17.952)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Group_776",
    "data-name": "Group 776"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2123",
    "data-name": "Path 2123",
    d: "M220.859,253.573a31.04,31.04,0,0,1-3.788-5.348c-.729-1.2-1.482-2.449-2.392-3.685-2.809-3.81-5.713-7.751-9.61-10.457a20.771,20.771,0,0,0-12.033-3.7.417.417,0,0,1-.382.027c-.642-.287-.038-3.04-.03-3.067a41.557,41.557,0,0,1,21.085-25.376l.349.75A40.739,40.739,0,0,0,193.389,227.6a12.063,12.063,0,0,0-.225,1.954,21.333,21.333,0,0,1,12.351,3.838c4.008,2.784,6.953,6.78,9.8,10.643.933,1.267,1.7,2.529,2.435,3.748a30.361,30.361,0,0,0,3.687,5.213Z",
    transform: "translate(-192.358 -201.971)",
    fill: "#ffc456"
  }))))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Group_796",
    "data-name": "Group 796",
    transform: "translate(31.361 81.221)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_779",
    "data-name": "Group 779",
    transform: "translate(51.843 8.1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2124",
    "data-name": "Path 2124",
    d: "M203.4,215.05a3.358,3.358,0,0,1,2.942.307c1.3,1.066.918,3.541.739,4.831a122.717,122.717,0,0,0-.988,14.248l-9.075-.229C198.619,228.356,200.769,220.693,203.4,215.05Z",
    transform: "translate(-197.015 -214.856)",
    fill: "#e98b4a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_783",
    "data-name": "Group 783",
    transform: "translate(1.38 42.778)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_782",
    "data-name": "Group 782"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_781",
    "data-name": "Group 781"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2126",
    "data-name": "Path 2126",
    d: "M169.689,269.1c-3.96,12.816-11.321,36.615-15.321,49.538l-20.2-6.467c1.373-5.649,11.88-48.965,13.514-55.705Z",
    transform: "translate(-134.172 -256.466)",
    fill: "#ff6b4a"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_790",
    "data-name": "Group 790",
    transform: "translate(0 44.505)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_786",
    "data-name": "Group 786"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_785",
    "data-name": "Group 785"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_784",
    "data-name": "Group 784"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2127",
    "data-name": "Path 2127",
    d: "M182.881,258.545c-10.472,9.982-40.368,38.8-46.582,44.329-2.367,1.844-7.447,7.441.249,16.352,7.861,8.976,18.019,2.992,18.019,2.992l8.953-11.151c4.863-5.518,14.765-19.476,19.1-25.682l14.051-26.846Z",
    transform: "translate(-132.453 -258.538)",
    fill: "#ffb27d"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_789",
    "data-name": "Group 789",
    transform: "translate(25.639 43.069)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_788",
    "data-name": "Group 788"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_787",
    "data-name": "Group 787"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2128",
    "data-name": "Path 2128",
    d: "M177.736,311.024a55.214,55.214,0,0,1-12.623,12.359l-.731-1.108a53.559,53.559,0,0,0,12.326-12.059Z",
    transform: "translate(-164.382 -310.216)",
    fill: "#c16424"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_795",
    "data-name": "Group 795",
    transform: "translate(36.259)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_791",
    "data-name": "Group 791"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2129",
    "data-name": "Path 2129",
    d: "M177.731,226.278c-1.342,5.971,8.721,17.112,9.181,21.583,2.445,8.725-.6,14.771,6.923,14.367,10.913-2.5,8.972-13.354,8.378-21.929-.833-9.454,4.819-15.2-3.642-18.148,7.142.065-.045-4.535-2.914-5.294a9.981,9.981,0,0,0-5.828.378c7.636-5.074,8.379-8.074,6.557-12.1C188.285,211.7,179.262,218.243,177.731,226.278Z",
    transform: "translate(-177.608 -205.137)",
    fill: "#ffb27d"
  }))))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Group_831",
    "data-name": "Group 831",
    transform: "translate(83.987)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_797",
    "data-name": "Group 797",
    transform: "translate(2.113 10.506)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2133",
    "data-name": "Path 2133",
    d: "M210.149,122.346c14.773,9.57-8.483,11.47-6.508,22.963-7.792-6.9,1.652-17.574,4.27-25.022A4.8,4.8,0,0,0,210.149,122.346Z",
    transform: "translate(-200.621 -120.287)",
    fill: "#392719"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_798",
    "data-name": "Group 798",
    transform: "translate(0 15.794)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2134",
    "data-name": "Path 2134",
    d: "M204,192.6c-10.006-7.71-5.321-30.549-1.557-48.9,1.434-6.994,2.673-13.035,2.83-17.061l.8.033c-.159,4.1-1.4,10.17-2.847,17.2-3.52,17.163-8.342,40.669,1.25,48.059Z",
    transform: "translate(-197.99 -126.632)",
    fill: "#392719"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_830",
    "data-name": "Group 830",
    transform: "translate(3.579)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_829",
    "data-name": "Group 829"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_801",
    "data-name": "Group 801",
    transform: "translate(0 6.448)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_800",
    "data-name": "Group 800"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_799",
    "data-name": "Group 799"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2135",
    "data-name": "Path 2135",
    d: "M253.745,151.4c3.927,1.334,6.524,6.683,3.936,13.42-2.581,6.7-12.9,5.357-12.9,5.357V167.5c-5.8,13.275-21.77,23.114-35.474,16a10.583,10.583,0,0,1-1.949-1.272,32.115,32.115,0,0,1-4.677-20.425,29,29,0,0,1,2.12-7.767c-.418-1.709-3.888-16.91,5.592-28.472,8.534-10.408,24.281-13.355,36.969-6.286C256.916,124.606,265.51,142.216,253.745,151.4Z",
    transform: "translate(-202.447 -115.418)",
    fill: "#ffb27d"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_803",
    "data-name": "Group 803",
    transform: "translate(4.199)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_802",
    "data-name": "Group 802"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2136",
    "data-name": "Path 2136",
    d: "M285.118,220.207c7.657-9.109-3.222-19.47-7.876-27.205-5.344-9.777-4-21.8-4.995-32.992-5.627-41.691-23.406-68.766-64.376-41.056-1.5,7.27,5.832,13.2,12.659,15.45,24.895,5.118,27.714,19.843,23.675,39.685-1.151,9.683-5.47,18.79-1.9,24.866,3.626,6.336,20.388,8.668,25.123,7.328C274.915,209.664,282.652,212.128,285.118,220.207Z",
    transform: "translate(-207.676 -107.681)",
    fill: "#392719"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_815",
    "data-name": "Group 815",
    transform: "translate(41.543 43.559)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_806",
    "data-name": "Group 806"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_805",
    "data-name": "Group 805"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_804",
    "data-name": "Group 804"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2137",
    "data-name": "Path 2137",
    d: "M265.571,169.658c-3.1,10.235-14.072,6.534-10.779-3.635C257.888,155.787,268.864,159.489,265.571,169.658Z",
    transform: "translate(-254.182 -159.947)",
    fill: "#ffb27d"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_810",
    "data-name": "Group 810",
    transform: "translate(2.949 2.835)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_809",
    "data-name": "Group 809"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_808",
    "data-name": "Group 808"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_807",
    "data-name": "Group 807"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2138",
    "data-name": "Path 2138",
    d: "M262.4,164.086c-1.647,1.679-4.2,4.188-2.786,6.726a.519.519,0,0,1-.365.761c-1.664.231-1.512-2.386-1.188-3.412-.181-1.273,4.743-6.781,4.34-4.075Z",
    transform: "translate(-257.854 -163.348)",
    fill: "#e27867"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_814",
    "data-name": "Group 814",
    transform: "translate(3.591 5.719)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_813",
    "data-name": "Group 813"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_812",
    "data-name": "Group 812"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_811",
    "data-name": "Group 811"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2139",
    "data-name": "Path 2139",
    d: "M258.668,168.679c2.538-4.706,8.859,1.172,2.649-.606-.828-.358-2.85,1.96-2.649.606Z",
    transform: "translate(-258.654 -166.809)",
    fill: "#e27867"
  })))))))))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Group_839",
    "data-name": "Group 839",
    transform: "translate(136.464 111.555)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_834",
    "data-name": "Group 834",
    transform: "translate(14.715)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_833",
    "data-name": "Group 833"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_832",
    "data-name": "Group 832"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2147",
    "data-name": "Path 2147",
    d: "M281.666,255.188s11.862-16.674,15.019-13.17c2.337,7.293,31.711,83.066,7.739,85.2,0,0-11.455-17.412-11.455-28.126S281.666,255.188,281.666,255.188Z",
    transform: "translate(-281.666 -241.534)",
    fill: "#ffb27d"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_838",
    "data-name": "Group 838",
    transform: "translate(0 59.587)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_837",
    "data-name": "Group 837",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_836",
    "data-name": "Group 836"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_835",
    "data-name": "Group 835"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2148",
    "data-name": "Path 2148",
    d: "M263.341,322.792c1.06,1.442,35.433,18.979,35.433,18.979,37.189-23.376-23.228-30.433-22-29.625Z",
    transform: "translate(-263.341 -312.085)",
    fill: "#ffb27d"
  }))))))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Group_840",
    "data-name": "Group 840",
    transform: "translate(147.212 107.109)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2149",
    "data-name": "Path 2149",
    d: "M280.362,254.219s11.267,42.326,10.841,45.419,5.109,17.234.426,20.769c-7.592,4.059-11.244-1.673-14.9-3.977,0,0,.951,12.53,4.52,15.987s29.968,6.55,31.671-4.056,5.109-23.862,5.109-23.862-14.9-63.192-20.012-67.17S283.768,240.078,280.362,254.219Z",
    transform: "translate(-276.726 -236.2)",
    fill: "#ffc456"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "Group_841",
    "data-name": "Group 841",
    transform: "translate(31.394 122.482)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2150",
    "data-name": "Path 2150",
    d: "M170.547,302.959c-4.231,4.86-12.116,13.2-15.971,18.611-10.822,7.584-30.169-8.032-18.422-19.228l10.888-47.7c1.518,1.225,27.178,9.729,26.107,12.43-3.69,5.039-11.037,8-15.394,11.764C154.658,276.5,166.047,303.927,170.547,302.959Z",
    transform: "translate(-132.494 -254.646)",
    fill: "#ffb937"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_843",
    "data-name": "Group 843",
    transform: "translate(41.297 144.311)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "Group_842",
    "data-name": "Group 842"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2151",
    "data-name": "Path 2151",
    d: "M145.513,298.467l-.687-.431c2.941-5.038,7.808-8.61,12.514-12.064,2.232-1.638,4.54-3.332,6.56-5.134l.524.632c-2.048,1.828-4.372,3.533-6.619,5.183C153.164,290.057,148.367,293.578,145.513,298.467Z",
    transform: "translate(-144.826 -280.838)",
    fill: "#ffc456"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_845",
    "data-name": "Group 845",
    transform: "translate(50.806 140.716)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "Group_844",
    "data-name": "Group 844"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2152",
    "data-name": "Path 2152",
    d: "M160.861,285.581a12.51,12.51,0,0,0-4.193-8.418l.516-.638a13.363,13.363,0,0,1,4.478,8.989Z",
    transform: "translate(-156.668 -276.525)",
    fill: "#ffc456"
  })))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "Group_905",
    "data-name": "Group 905",
    transform: "translate(90.11 114.535)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_846",
    "data-name": "Group 846",
    transform: "translate(0 6.001)",
    opacity: 0.69
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2153",
    "data-name": "Path 2153",
    d: "M268.521,262.879c.613,14.091-63.524,14.089-62.9,0C205.006,248.787,269.142,248.79,268.521,262.879Z",
    transform: "translate(-205.614 -252.311)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_855",
    "data-name": "Group 855",
    transform: "translate(40.97)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_851",
    "data-name": "Group 851"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_847",
    "data-name": "Group 847",
    transform: "translate(12.732 6.494)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2154",
    "data-name": "Path 2154",
    d: "M283.415,260.64c1.045-.48.98-1.9,1.412-2.86-.032-.634-.767.163-1.072.21a.2.2,0,0,1-.2-.327c.928-.534,3.59-5,.985-2.511a.191.191,0,0,1-.293-.235c1.746-4.817-1.486.439-2.271,1.041.358-.876-.54-.213-.781.048-.233.2-.315-.288-.548-.153-.393.023-1.345,1.363-1.433.629a.19.19,0,0,0-.322-.172,7.9,7.9,0,0,0-.863.963c-.454,1.53-2.269,2.405-2.184,4.2-.079,1.932-4.137,3.78-3.217,3.507a14.154,14.154,0,0,0,2.517-.79c3.268-2.359,4.435,1.064,7.846-1.559C283.161,262.011,282.758,261.064,283.415,260.64Z",
    transform: "translate(-272.491 -252.903)",
    fill: "#a5ae39"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_848",
    "data-name": "Group 848",
    transform: "translate(11.942 15.271)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2155",
    "data-name": "Path 2155",
    d: "M271.651,263.434c-.048.05-.093.1-.144.15A1.9,1.9,0,0,0,271.651,263.434Z",
    transform: "translate(-271.507 -263.434)",
    fill: "#a5ae39"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_849",
    "data-name": "Group 849",
    transform: "translate(8.858)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2156",
    "data-name": "Path 2156",
    d: "M276.87,253.9a.139.139,0,0,1,.173-.128l.811.212a.14.14,0,0,0,.174-.14,2.067,2.067,0,0,0-.522-1.129.142.142,0,0,1-.029-.139c.168-.433.585-.372.947-.453.229-.051.276-.2.119-.357a2.351,2.351,0,0,0-.527-.4,2.555,2.555,0,0,0-1.3-.324.144.144,0,0,1-.12-.228,39.811,39.811,0,0,0,3.186-5.5.145.145,0,0,0-.153-.207,2.585,2.585,0,0,0-1.287.4.585.585,0,0,0,.083-.4,3.069,3.069,0,0,0-1.335,1.039.137.137,0,0,1-.246-.024.138.138,0,0,0-.238-.04,14.072,14.072,0,0,0-1.777,3.273.138.138,0,0,1-.265-.045,34.806,34.806,0,0,0-.629-4.042.14.14,0,0,0-.235-.072c-.239.226-.528.391-.735.631a.136.136,0,0,1-.236-.067,1.866,1.866,0,0,0-.116-.345.137.137,0,0,0-.26.034,4.284,4.284,0,0,1-.466,1.23.139.139,0,0,1-.255-.026c-.094-.288-.172-.508-.266-.8a.138.138,0,0,0-.255-.024,6.991,6.991,0,0,0-.861,2.959.137.137,0,0,1-.259.059,2.446,2.446,0,0,0-.321-.443.538.538,0,0,0-.432-.225c-.271.037-.359.394-.37.678a6.3,6.3,0,0,0,.077,1.153.139.139,0,0,1-.224.132,3.462,3.462,0,0,0-.86-.522.144.144,0,0,0-.189.178,5.761,5.761,0,0,0,1.783,2.789c.974.828,2.3,1.412,2.685,2.655a3.967,3.967,0,0,1-.242,2.429,7.864,7.864,0,0,1-1.005,2.691c1.583-1.655,1.755-3.24,3.251-5.074l.45-.553a.137.137,0,0,1,.168-.038,2.342,2.342,0,0,1,.841.739.134.134,0,0,0,.162.054A1.879,1.879,0,0,0,276.87,253.9Z",
    transform: "translate(-267.666 -245.11)",
    fill: "#a5ae39"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_850",
    "data-name": "Group 850",
    transform: "translate(0 1.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2157",
    "data-name": "Path 2157",
    d: "M264.755,254.637c-.124-1.083-.049-3.968-1.326-4.185a26.477,26.477,0,0,0-1.593-3.242,5.847,5.847,0,0,0-.687,3.36,12.96,12.96,0,0,1-.662-2.449c-1.429.877-2.041,2.589-.661,3.807-1.64-.374-4.107-1.3-1.987,1.345-3.927,1.438,2.916,2.35,3.954,3.169-.172-.009-.447.545-.316.711,1.506.067,3.418-.157,4.18,1.528A19.347,19.347,0,0,0,264.755,254.637Z",
    transform: "translate(-256.635 -247.21)",
    fill: "#a5ae39"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_852",
    "data-name": "Group 852",
    transform: "translate(8.95 5.557)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2158",
    "data-name": "Path 2158",
    d: "M274.21,251.778a31.194,31.194,0,0,1-.772,4.012c-.333,1.323-.717,2.631-1.139,3.929s-.889,2.581-1.4,3.85a31.988,31.988,0,0,1-1.769,3.75.709.709,0,0,1-.99.266.767.767,0,0,1-.256-1.028c.011-.019.023-.038.036-.057l.006-.009a30.375,30.375,0,0,0,1.995-3.405c.609-1.188,1.176-2.405,1.709-3.64s1.022-2.492,1.467-3.767A30.829,30.829,0,0,0,274.21,251.778Z",
    transform: "translate(-267.781 -251.778)",
    fill: "#7d8c0f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_853",
    "data-name": "Group 853",
    transform: "translate(5.847 8.541)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2159",
    "data-name": "Path 2159",
    d: "M263.921,255.358a3.163,3.163,0,0,1,.756.563,8.754,8.754,0,0,1,.646.7,17.436,17.436,0,0,1,1.135,1.542q.529.8.993,1.649a14.015,14.015,0,0,1,.829,1.773c.056.158.111.318.155.49.022.084.043.173.059.266s.023.175.035.263a7.952,7.952,0,0,1,.041,1.018c-.012.667-.069,1.322-.144,1.972a38.548,38.548,0,0,1-.656,3.869.722.722,0,0,1-.867.562.751.751,0,0,1-.542-.9.589.589,0,0,1,.022-.077l0-.008a36.835,36.835,0,0,0,1.013-3.631c.136-.613.255-1.231.33-1.845a7.126,7.126,0,0,0,.058-.9,2.088,2.088,0,0,0-.034-.423c-.023-.142-.059-.289-.1-.436a13.509,13.509,0,0,0-.646-1.756c-.253-.577-.532-1.144-.834-1.7a17.339,17.339,0,0,0-.986-1.614,8.54,8.54,0,0,0-.575-.747,3.139,3.139,0,0,0-.7-.622l0,0Z",
    transform: "translate(-263.917 -255.358)",
    fill: "#7d8c0f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_854",
    "data-name": "Group 854",
    transform: "translate(8.566 13.296)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2160",
    "data-name": "Path 2160",
    d: "M267.37,269.581a4.4,4.4,0,0,1,1.32-1.717,17.164,17.164,0,0,1,1.552-1.081c.125-.082.249-.164.369-.248s.259-.18.391-.265c.264-.173.532-.333.8-.486.543-.305,1.1-.574,1.65-.83l.832-.378a6.6,6.6,0,0,0,.767-.458c.507-.334,1.009-.68,1.51-1.026l1.506-1.037c.507-.339,1-.7,1.535-.993-.515.324-.992.708-1.48,1.073l-1.452,1.118c-.484.373-.968.745-1.461,1.109-.247.18-.5.363-.771.526l-.771.488c-.511.328-1.013.666-1.49,1.028-.238.181-.47.368-.694.563-.113.1-.218.195-.331.3s-.235.212-.353.315a16.549,16.549,0,0,0-1.311,1.205,3.065,3.065,0,0,0-.764,1.3.722.722,0,0,1-.882.541.754.754,0,0,1-.521-.916.685.685,0,0,1,.032-.1Z",
    transform: "translate(-267.303 -261.064)",
    fill: "#7d8c0f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_872",
    "data-name": "Group 872",
    transform: "translate(32.966 9.627)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_857",
    "data-name": "Group 857",
    transform: "translate(0.803)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_856",
    "data-name": "Group 856"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2161",
    "data-name": "Path 2161",
    d: "M269.046,259.638c4.528,4.078,3.984,10.429,3.829,12.254-.011,10.568-14.216,14.175-21.323,8.677-5.215-5.463-4.9-14.095-.707-19.69C255.623,256.314,262.573,254.808,269.046,259.638Z",
    transform: "translate(-247.668 -256.661)",
    fill: "#da2e07"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_859",
    "data-name": "Group 859",
    transform: "translate(0 1.233)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_858",
    "data-name": "Group 858"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2162",
    "data-name": "Path 2162",
    d: "M268.046,261.117c4.528,4.078,3.984,10.429,3.828,12.255-.01,10.567-14.216,14.174-21.323,8.677-5.215-5.463-4.9-14.1-.707-19.691C254.623,257.793,261.573,256.288,268.046,261.117Z",
    transform: "translate(-246.668 -258.141)",
    fill: "#ec6c2a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_861",
    "data-name": "Group 861",
    transform: "translate(3.704 6.502)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_860",
    "data-name": "Group 860"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2163",
    "data-name": "Path 2163",
    d: "M251.438,264.463l17.814,16.264c-.016.02-.145.163-.164.185l-17.807-16.257Z",
    transform: "translate(-251.281 -264.463)",
    fill: "#da2e07"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_863",
    "data-name": "Group 863",
    transform: "translate(1.146 2.379)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_862",
    "data-name": "Group 862"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2164",
    "data-name": "Path 2164",
    d: "M268.65,279.872c-4.021,4.325-12.675,5.049-17.014,1.46-4.755-4.96-4.465-12.773-.649-17.9C263.514,252.19,277.167,267.5,268.65,279.872Zm-17.6-16.141c-7.393,11.479,1.04,24.131,14.284,18.252,6.924-2.394,7.067-15.561,2.041-19.489C264.333,259.438,255.8,258.366,251.053,263.731Z",
    transform: "translate(-248.095 -259.516)",
    fill: "#da2e07"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_865",
    "data-name": "Group 865",
    transform: "translate(2.846 4.367)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_864",
    "data-name": "Group 864"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2165",
    "data-name": "Path 2165",
    d: "M267.728,279.081c-3.423,3.683-10.792,4.3-14.488,1.243-4.07-4.36-3.818-10.742-.552-15.244,4.2-4.566,11.448-3.59,14.093-.96h0C270.35,266.869,270.952,275.323,267.728,279.081ZM252.771,265.36c-3.056,4.387-3.312,10.539.625,14.771,10.867,7.1,22.018-5.846,13.226-15.821h0C264.038,261.715,256.794,260.813,252.771,265.36Z",
    transform: "translate(-250.212 -261.901)",
    fill: "#da2e07"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_867",
    "data-name": "Group 867",
    transform: "translate(4.253 5.901)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_866",
    "data-name": "Group 866"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2166",
    "data-name": "Path 2166",
    d: "M266.935,278.377c-9.133,7.775-19.565-1.743-12.81-11.926,3.581-3.891,9.748-3.059,12-.818h0C269.17,267.977,269.682,275.176,266.935,278.377Zm-12.713-11.663c-2.6,3.843-2.83,8.813.528,12.529,9.034,6.121,18.746-5.155,11.22-13.42h0C263.779,263.624,257.634,262.857,254.222,266.714Z",
    transform: "translate(-251.965 -263.742)",
    fill: "#da2e07"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_869",
    "data-name": "Group 869",
    transform: "translate(6.52 7.83)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_868",
    "data-name": "Group 868"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2167",
    "data-name": "Path 2167",
    d: "M266.572,277.743c-12.671,8.765-17.829-18.394-1.608-10.084h0C267.7,270,268.829,274.431,266.572,277.743Zm-10.813-9.793c-5.281,15.765,20.254,13.865,9.056-.093h0A7.351,7.351,0,0,0,255.759,267.95Z",
    transform: "translate(-254.787 -266.057)",
    fill: "#da2e07"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_871",
    "data-name": "Group 871",
    transform: "translate(7.147 9.585)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_870",
    "data-name": "Group 870"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2168",
    "data-name": "Path 2168",
    d: "M266.729,278.15c-5.746.637-10.144-6.456-11.161-9.988C261.692,270.07,265.828,271.7,266.729,278.15Zm-10.713-9.514c1.18,3.814,5.515,9.593,10.422,9.321C265.736,272.3,261.385,270.021,256.016,268.636Z",
    transform: "translate(-255.568 -268.162)",
    fill: "#da2e07"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_873",
    "data-name": "Group 873",
    transform: "translate(0.353 1.84)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2169",
    "data-name": "Path 2169",
    d: "M208.5,265.5a5.592,5.592,0,0,1-1.1-8.252c.046-3.038-1.758-7.154.873-9.441,2.953-1.812,5.669,1.783,5.906,4.691,3.84-1.474,4.29,4.55,4.051,7.413-.649-7.514,7.942-10,13.36-6.835,1.242-2.859,6.427-5.381,8.382-2.067,3.263-.993,8.485-.489,8.322,4.1,2.327,1.44,2.01,6.7.121,8.581-3.694,3.414-7.408,7.55-12.179,8.905C229.967,274.661,209.5,273.6,208.5,265.5Z",
    transform: "translate(-206.054 -247.318)",
    fill: "#a5ae39"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_891",
    "data-name": "Group 891",
    transform: "translate(17.684 5.201)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_874",
    "data-name": "Group 874"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2170",
    "data-name": "Path 2170",
    d: "M251.243,263.365c-.069,16.021-23.538,16.019-23.606,0C227.706,247.346,251.175,247.346,251.243,263.365Z",
    transform: "translate(-227.637 -251.351)",
    fill: "#d18205"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_875",
    "data-name": "Group 875",
    transform: "translate(1.18 1.202)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2171",
    "data-name": "Path 2171",
    d: "M250.352,263.606c-.062,14.419-21.185,14.417-21.245,0C229.17,249.188,250.292,249.189,250.352,263.606Z",
    transform: "translate(-229.107 -252.793)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_890",
    "data-name": "Group 890",
    transform: "translate(2.154 2.003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_877",
    "data-name": "Group 877",
    transform: "translate(6.304 11.939)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_876",
    "data-name": "Group 876"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2172",
    "data-name": "Path 2172",
    d: "M241.612,275.957c-5.119.4-3.4-1.051-1.981-4.541.479-.748,1.4-4.8,2.75-2.778.653,1.494,2,4.575,2.653,6.081C245.68,276.589,242.431,275.8,241.612,275.957Z",
    transform: "translate(-238.17 -268.08)",
    fill: "#f7a303"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_879",
    "data-name": "Group 879",
    transform: "translate(0.535 10.913)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_878",
    "data-name": "Group 878"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2173",
    "data-name": "Path 2173",
    d: "M232.82,272.065c-.386-.768-3.018-2.9-1.2-3.549,1.548-.4,4.7-1.237,6.235-1.639a.867.867,0,0,1,.959,1.248c-.718,1.461-2.2,4.473-2.926,5.945C234.88,275.76,233.45,272.632,232.82,272.065Z",
    transform: "translate(-230.986 -266.849)",
    fill: "#f7a303"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_881",
    "data-name": "Group 881",
    transform: "translate(0 4.53)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_880",
    "data-name": "Group 880"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2174",
    "data-name": "Path 2174",
    d: "M230.867,262.505c.763-5.269,1.743-3.2,4.706-.994,3.741,2.659,3.609,3.3-.882,4.01C231.1,266.174,229.35,267.6,230.867,262.505Z",
    transform: "translate(-230.319 -259.19)",
    fill: "#f7a303"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_883",
    "data-name": "Group 883",
    transform: "translate(2.756 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_882",
    "data-name": "Group 882"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2175",
    "data-name": "Path 2175",
    d: "M236.647,254.956c4.445-2.666,3.5-.583,3.683,3.2-.12.889.744,4.951-1.317,3.741l-4.933-4.284C232.718,256.218,235.975,255.467,236.647,254.956Z",
    transform: "translate(-233.751 -253.755)",
    fill: "#f7a303"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_885",
    "data-name": "Group 885",
    transform: "translate(10.075)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_884",
    "data-name": "Group 884"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2176",
    "data-name": "Path 2176",
    d: "M246.63,254.956c.669.517,3.933,1.258,2.566,2.657-1.226,1.061-3.716,3.23-4.933,4.284-2.056,1.206-1.2-2.849-1.317-3.742C243.133,254.375,242.184,252.288,246.63,254.956Z",
    transform: "translate(-242.866 -253.754)",
    fill: "#f7a303"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_887",
    "data-name": "Group 887",
    transform: "translate(11.581 4.529)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_886",
    "data-name": "Group 886"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2177",
    "data-name": "Path 2177",
    d: "M252.1,262.505c1.516,5.09-.23,3.67-3.825,3.015-4.482-.711-4.63-1.348-.881-4.01C250.361,259.3,251.342,257.234,252.1,262.505Z",
    transform: "translate(-244.741 -259.189)",
    fill: "#f7a303"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_889",
    "data-name": "Group 889",
    transform: "translate(11.035 10.914)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_888",
    "data-name": "Group 888"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2178",
    "data-name": "Path 2178",
    d: "M250.15,272.066c-.634.562-2.056,3.7-3.067,2.005-.724-1.477-2.207-4.48-2.926-5.945a.866.866,0,0,1,.959-1.248l6.235,1.638C253.162,269.159,250.542,271.3,250.15,272.066Z",
    transform: "translate(-244.062 -266.85)",
    fill: "#f7a303"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_894",
    "data-name": "Group 894",
    transform: "translate(32.281 13.241)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_892",
    "data-name": "Group 892"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2179",
    "data-name": "Path 2179",
    d: "M265.476,271.436c4.154-14.7-8.518-11.255-15.687-5.485C236.529,278.571,260.263,293.055,265.476,271.436Z",
    transform: "translate(-245.815 -260.998)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_893",
    "data-name": "Group 893",
    transform: "translate(3.777 5.576)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2180",
    "data-name": "Path 2180",
    d: "M260.617,277.4c-4.656,5.932-13.527-1.793-8.7-7.582C256.568,263.889,265.439,271.614,260.617,277.4Z",
    transform: "translate(-250.518 -267.688)",
    fill: "#ffc456"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_898",
    "data-name": "Group 898",
    transform: "translate(4.591 9.937)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_896",
    "data-name": "Group 896"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_895",
    "data-name": "Group 895"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2181",
    "data-name": "Path 2181",
    d: "M212.458,264l-.055-.125-.057-.133c-.028-.067-.058-.134-.085-.2q-.289-.69-.528-1.4a7.155,7.155,0,0,1-.376-1.535l0,0a3.356,3.356,0,0,1,.02-.923,2.727,2.727,0,0,1,.165-.583v0a2.631,2.631,0,0,1,.154-.314,1.833,1.833,0,0,1,.1-.16,3.51,3.51,0,0,1,1.812-1.343,4.056,4.056,0,0,1,.666-.174c.073-.011.144-.021.218-.03a3.96,3.96,0,0,1,1.43.073c.142.034.28.071.416.117.106.033.21.07.312.11a6.649,6.649,0,0,1,1.025.51q.19.116.377.242l0,0a18.158,18.158,0,0,1,2.607,2.311,33.761,33.761,0,0,0,5.476,4.834,10.456,10.456,0,0,0,6.83,1.884c1.641-.2,3.2-.927,4.844-1.033a7.382,7.382,0,0,1,2.973.583l.367.155a7.482,7.482,0,0,1,1.165.646v0c.073.05.146.1.217.157a4.359,4.359,0,0,1,.911.9l.148.218a2.437,2.437,0,0,1,.315.781,1.954,1.954,0,0,1,.034.2v0c.006.053.01.108.014.164a2.033,2.033,0,0,1-.01.334l-.038.234a2.791,2.791,0,0,1-.263.713c-.016.028-.031.057-.047.088-.026.046-.053.092-.08.139a6.111,6.111,0,0,1-.889,1.113c-.105.109-.218.216-.334.318a12.82,12.82,0,0,1-2.994,1.934l-.1.048v0a19.208,19.208,0,0,1-4.346,1.455,18.767,18.767,0,0,1-2.635.323h-.044c-.513.027-1.028.031-1.543.015h-.035l0,0a19.948,19.948,0,0,1-9.811-2.964,20.838,20.838,0,0,1-4.478-3.753l0,0q-.418-.464-.813-.954v0A22.4,22.4,0,0,1,212.458,264Z",
    transform: "translate(-211.332 -257.034)",
    fill: "#e0e069"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_897",
    "data-name": "Group 897",
    transform: "translate(0.804 6.567)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2182",
    "data-name": "Path 2182",
    d: "M212.543,265.051a67.593,67.593,0,0,0,9.527,7.129c7.354,4.808,13.771,3.566,17.856,1.685a19.778,19.778,0,0,0,2.064-1.1q.438-.271.807-.523a16.784,16.784,0,0,0,1.351-1.018,2.035,2.035,0,0,1-.01.334l-.038.234a2.876,2.876,0,0,1-.31.8,5.95,5.95,0,0,1-.969,1.253c-.105.109-.218.216-.334.318a17.086,17.086,0,0,1-7.444,3.439,18.762,18.762,0,0,1-2.635.323h-.044c-.513.027-1.028.031-1.543.015h-.035l0,0a19.949,19.949,0,0,1-9.811-2.964,20.839,20.839,0,0,1-4.478-3.753l0,0q-.418-.464-.813-.954v0a22.4,22.4,0,0,1-3.02-4.954c-.067-.153-.258-.239-.322-.4.088.091.177.182.267.271Z",
    transform: "translate(-212.333 -264.913)",
    fill: "#598b4c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_900",
    "data-name": "Group 900",
    transform: "translate(0.147 16.966)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_899",
    "data-name": "Group 899"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2183",
    "data-name": "Path 2183",
    d: "M258.687,305.612c-9.181,5.777-32.155,6.367-41.838.819L205.8,266.286c15.158,10.673,47.769,10.543,63.151-.819Z",
    transform: "translate(-205.798 -265.467)",
    fill: "#f5eedc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_902",
    "data-name": "Group 902",
    transform: "translate(9.639 52.191)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_901",
    "data-name": "Group 901"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2184",
    "data-name": "Path 2184",
    d: "M217.618,307.816c13.137,3.85,31.116,3.825,44.647-.083h.008l-.136.525-.1.392a84.919,84.919,0,0,1-22.42,2.85,81.674,81.674,0,0,1-21.737-2.75Z",
    transform: "translate(-217.618 -307.733)",
    fill: "#7bc6a8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_904",
    "data-name": "Group 904",
    transform: "translate(4.516 24.99)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_903",
    "data-name": "Group 903"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2185",
    "data-name": "Path 2185",
    d: "M238.03,279.784a3.156,3.156,0,0,0-1.661,4.233,4.8,4.8,0,0,0,.89,1.391,6.2,6.2,0,0,0,1.383-1.382C239.645,282.589,239.433,281.126,238.03,279.784Zm11.739.085c-1.861.182-2.977.993-3.149,2.294a3.572,3.572,0,0,0,.659,2.418c1.444-.95,2.666-2.067,2.918-3.165A1.7,1.7,0,0,0,249.769,279.869ZM227.058,278.2a1.6,1.6,0,0,0-1.011.334c-.794.623-1.137,2.079-.872,3.707a7,7,0,0,0,.489,1.663,8.131,8.131,0,0,0,1.523-1.327,4.188,4.188,0,0,0,1.106-4.075A3.1,3.1,0,0,0,227.058,278.2Zm29.985.773a1.733,1.733,0,0,0-.969.415,2.6,2.6,0,0,0-.279,3.458,3.776,3.776,0,0,0,.556.631,16.83,16.83,0,0,0,1.094-1.628,2.178,2.178,0,0,0,.165-2.624A.752.752,0,0,0,257.043,278.969Zm-40.768-3.036a1.009,1.009,0,0,0-.553.159c-.83.53-1.188,2.333-.834,4.192a8.028,8.028,0,0,0,.359,1.273c.114-.108.225-.217.332-.33a6.582,6.582,0,0,0,1.979-4.756A2.307,2.307,0,0,0,216.275,275.933Zm-5.037,7.837a9.123,9.123,0,0,0,3.365-1.658,8.217,8.217,0,0,1-.5-1.667c-.434-2.25.056-4.334,1.2-5.059.57-.367,1.534-.567,2.9.542l.137.108.016.192a7.377,7.377,0,0,1-2.2,5.584c-.177.192-.361.367-.554.542a5.3,5.3,0,0,0,3.887,2.984,7.675,7.675,0,0,0,5.484-1.008,8.173,8.173,0,0,1-.586-1.95c-.321-1.958.137-3.692,1.18-4.509a2.845,2.845,0,0,1,3.22-.05l.153.067.056.158a4.954,4.954,0,0,1-1.213,5.092,9.344,9.344,0,0,1-1.734,1.508,4.736,4.736,0,0,0,2.513,2.109l.088.042c1.991,1.267,5.493.575,7.926-.917a5.715,5.715,0,0,1-.94-1.533c-.707-1.725-.482-4.059,2.289-5.434l.233-.117.2.175c1.887,1.667,2.232,3.692.939,5.551a7.177,7.177,0,0,1-1.437,1.458,4.854,4.854,0,0,0,4.826.892A22.437,22.437,0,0,0,246.6,285a4.422,4.422,0,0,1-.779-2.95c.112-.833.731-2.784,4.079-3.034l.185-.008.128.133a2.607,2.607,0,0,1,.763,2.467c-.305,1.333-1.646,2.592-3.18,3.617a4.905,4.905,0,0,0,1.783,1.183c1.06.392,3.541.808,6.255-2.309a4.412,4.412,0,0,1-.691-.775,3.443,3.443,0,0,1,.4-4.567c1.012-.792,1.975-.825,2.634-.117a2.956,2.956,0,0,1-.08,3.684,16.886,16.886,0,0,1-1.1,1.633,3.743,3.743,0,0,0,3.63.267,15.635,15.635,0,0,0,6.488-5.817l-.546,2.117a15.861,15.861,0,0,1-5.6,4.459,4.561,4.561,0,0,1-4.481-.383c-3.035,3.559-5.942,3.05-7.179,2.592a5.672,5.672,0,0,1-2.2-1.525,24.622,24.622,0,0,1-4.152,1.992,5.626,5.626,0,0,1-5.8-1.192,11.433,11.433,0,0,1-5.886,1.809,5.729,5.729,0,0,1-3-.75,5.552,5.552,0,0,1-2.915-2.459,8.346,8.346,0,0,1-6.039,1.075,6.073,6.073,0,0,1-4.36-3.275,9.989,9.989,0,0,1-3.493,1.7Z",
    transform: "translate(-211.238 -275.095)",
    fill: "#7bc6a8"
  }))))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "Group_927",
    "data-name": "Group 927",
    transform: "translate(105.023 144.615)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_908",
    "data-name": "Group 908",
    transform: "translate(0 2.556)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_907",
    "data-name": "Group 907"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_906",
    "data-name": "Group 906"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2186",
    "data-name": "Path 2186",
    d: "M267.294,320.632c-8.271,1.146-19.178-1.773-31.137-7.332a22.1,22.1,0,0,1-5.009-.72c-2.181-.662-10.025-13.882-5.662-12.559s12.284.04,12.267-.711c.882-.358,2.233-1.319,1.5-1.939a86.053,86.053,0,0,0-14.231-9.385l2.205-3.715c9.16,2.122,28.054,3.341,37.052,14.112C269.966,302.939,278.276,318.882,267.294,320.632Z",
    transform: "translate(-224.187 -284.27)",
    fill: "#ffb27d"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_911",
    "data-name": "Group 911",
    transform: "translate(26.903)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_910",
    "data-name": "Group 910"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_909",
    "data-name": "Group 909"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2187",
    "data-name": "Path 2187",
    d: "M276.663,309.206c.843,2.659-.145,6.151-1.2,8.984a19.04,19.04,0,0,1-2.794.842l-14.974-28.6c.948.047,6.267,1.388,6.557,1.428,9.063-.534,6.2-13.635,15.379-10.036l-3.694,11.234C275.843,293.464,275.55,306.508,276.663,309.206Z",
    transform: "translate(-257.69 -281.203)",
    fill: "#ffb27d"
  })))))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "Group_928",
    "data-name": "Group 928",
    transform: "translate(87.447 65.891)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2193",
    "data-name": "Path 2193",
    d: "M212.7,190.068c.272,18.678-5.35,5.041-7.8,26.094a14.645,14.645,0,0,0-2.6-1.726c.771-4.01,2.707-8.107,2.377-12.2-3.219-4.962.563-10.606,2.184-15.493.072.008.145.025.217.033.024,3.3-1.376,6.589-1.879,9.868,1.576,2.164,2.509-8.366,3.686-9.493.715,3.114-2.047,7.62-1.117,10.434,1.881-2.465,1.136-7.307,2.916-10.035,1.064,1.365-2.626,11.334-.274,10.352.914-3.107.45-7.252,2.048-9.918C212.9,188.5,212.616,189.4,212.7,190.068Z",
    transform: "translate(-202.298 -186.743)",
    fill: "#1c1c19"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "Group_943",
    "data-name": "Group 943",
    transform: "translate(126.502 26.4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_941",
    "data-name": "Group 941"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_930",
    "data-name": "Group 930",
    transform: "translate(3.827 9.363)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_929",
    "data-name": "Group 929"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2194",
    "data-name": "Path 2194",
    d: "M255.7,153.969c.041-4.616,7.026-4.443,6.854.17C262.516,158.755,255.531,158.582,255.7,153.969Z",
    transform: "translate(-255.7 -150.592)",
    fill: "#f5eedc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_932",
    "data-name": "Group 932",
    transform: "translate(0 6.782)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_931",
    "data-name": "Group 931"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2195",
    "data-name": "Path 2195",
    d: "M252.7,147.978c3.873-2.271,7.221,4.094,3.285,6.246C252.109,156.494,248.761,150.13,252.7,147.978Z",
    transform: "translate(-250.934 -147.495)",
    fill: "#f5eedc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_934",
    "data-name": "Group 934",
    transform: "translate(0.098 2.1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_933",
    "data-name": "Group 933"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2196",
    "data-name": "Path 2196",
    d: "M256.255,142.445c3.831,2.345.194,8.537-3.569,6.076C248.855,146.176,252.492,139.984,256.255,142.445Z",
    transform: "translate(-251.056 -141.877)",
    fill: "#f5eedc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_936",
    "data-name": "Group 936",
    transform: "translate(4.042)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_935",
    "data-name": "Group 935"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2197",
    "data-name": "Path 2197",
    d: "M262.826,142.9c-.042,4.616-7.026,4.443-6.854-.17C256.013,138.119,263,138.292,262.826,142.9Z",
    transform: "translate(-255.968 -139.358)",
    fill: "#f5eedc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_938",
    "data-name": "Group 938",
    transform: "translate(7.92 2.295)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_937",
    "data-name": "Group 937"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2198",
    "data-name": "Path 2198",
    d: "M265.845,148.839c-3.873,2.271-7.221-4.094-3.285-6.246C266.433,140.322,269.78,146.686,265.845,148.839Z",
    transform: "translate(-260.797 -142.111)",
    fill: "#f5eedc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_940",
    "data-name": "Group 940",
    transform: "translate(7.803 6.975)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_939",
    "data-name": "Group 939"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2199",
    "data-name": "Path 2199",
    d: "M262.281,154.371c-3.831-2.346-.194-8.537,3.569-6.076C269.682,150.641,266.045,156.832,262.281,154.371Z",
    transform: "translate(-260.651 -147.727)",
    fill: "#f5eedc"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_942",
    "data-name": "Group 942",
    transform: "translate(4.847 5.53)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_65",
    "data-name": "Ellipse 65",
    cx: 2.518,
    cy: 2.614,
    rx: 2.518,
    ry: 2.614,
    fill: "#ffc456"
  })))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "Group_977",
    "data-name": "Group 977",
    transform: "translate(87.711 57.088)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_944",
    "data-name": "Group 944",
    transform: "translate(0 4.87)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2200",
    "data-name": "Path 2200",
    d: "M204.06,190.9c-.835-1.573-1.813-4.9-1.282-6.953.723-2.19,4.7-2.122,6.129-1.654.3.207,4.356,4.255,5.465,5.361-.093.829-.247,2.218-.339,3.043Z",
    transform: "translate(-202.627 -182.023)",
    fill: "#70801d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_945",
    "data-name": "Group 945",
    transform: "translate(1.007 0.696)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2201",
    "data-name": "Path 2201",
    d: "M204.456,188.251c-1.421-3.8-.148-8.872,3.141-11.236q3.454,2.962,6.907,5.926l-1.812,5.861q-.941-.065-1.878-.125v0l-.344-.022v0c-1.266-.082-2.533-.171-3.8-.252l0,0C205.933,188.349,205.194,188.3,204.456,188.251Z",
    transform: "translate(-203.881 -177.015)",
    fill: "#a5ae39"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_946",
    "data-name": "Group 946",
    transform: "translate(9.779 6.569)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2202",
    "data-name": "Path 2202",
    d: "M214.8,189.948c.58-1.831,1.283-4.055,1.865-5.886l1.539,2.817c-.541,1.269-1.235,2.888-1.776,4.153Z",
    transform: "translate(-214.805 -184.062)",
    fill: "#a5ae39"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_948",
    "data-name": "Group 948",
    transform: "translate(6.97 12.759)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_947",
    "data-name": "Group 947"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2203",
    "data-name": "Path 2203",
    d: "M211.479,192.115a.329.329,0,1,1,.363-.544A.329.329,0,1,1,211.479,192.115Z",
    transform: "translate(-211.306 -191.489)",
    fill: "#eef7cb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_950",
    "data-name": "Group 950",
    transform: "translate(2.866 12.769)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_949",
    "data-name": "Group 949"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2204",
    "data-name": "Path 2204",
    d: "M206.4,192.144c-.446-.313-.078-.868.363-.544S206.838,192.467,206.4,192.144Z",
    transform: "translate(-206.196 -191.501)",
    fill: "#eef7cb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_952",
    "data-name": "Group 952",
    transform: "translate(4.767 12.489)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_951",
    "data-name": "Group 951"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2205",
    "data-name": "Path 2205",
    d: "M208.635,191.448a.15.15,0,1,1,.166-.249A.15.15,0,1,1,208.635,191.448Z",
    transform: "translate(-208.564 -191.165)",
    fill: "#eef7cb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_954",
    "data-name": "Group 954",
    transform: "translate(5.012 13.284)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_953",
    "data-name": "Group 953"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2206",
    "data-name": "Path 2206",
    d: "M208.94,192.4a.15.15,0,1,1,.166-.249A.15.15,0,1,1,208.94,192.4Z",
    transform: "translate(-208.869 -192.12)",
    fill: "#eef7cb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_956",
    "data-name": "Group 956",
    transform: "translate(8.888 12.797)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_955",
    "data-name": "Group 955"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2207",
    "data-name": "Path 2207",
    d: "M213.767,191.818a.15.15,0,1,1,.166-.25A.15.15,0,1,1,213.767,191.818Z",
    transform: "translate(-213.696 -191.535)",
    fill: "#eef7cb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_958",
    "data-name": "Group 958",
    transform: "translate(6.032 12.625)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_957",
    "data-name": "Group 957"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2208",
    "data-name": "Path 2208",
    d: "M210.21,191.612a.15.15,0,1,1,.166-.249A.15.15,0,1,1,210.21,191.612Z",
    transform: "translate(-210.139 -191.329)",
    fill: "#eef7cb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_960",
    "data-name": "Group 960",
    transform: "translate(1.736 12.676)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_959",
    "data-name": "Group 959"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2209",
    "data-name": "Path 2209",
    d: "M204.86,191.673a.15.15,0,1,1,.166-.25A.15.15,0,1,1,204.86,191.673Z",
    transform: "translate(-204.789 -191.39)",
    fill: "#eef7cb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_975",
    "data-name": "Group 975",
    transform: "translate(0.178 1.329)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_962",
    "data-name": "Group 962",
    transform: "translate(3.663)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_961",
    "data-name": "Group 961"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2210",
    "data-name": "Path 2210",
    d: "M207.41,177.926c.051-.053.1-.1.153-.151,6.87,9.127,5.093.921,9.188,8.057l-.053.128C212.254,178.917,214.448,187.141,207.41,177.926Z",
    transform: "translate(-207.41 -177.775)",
    fill: "#70801d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_964",
    "data-name": "Group 964",
    transform: "translate(2.046 2.101)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_963",
    "data-name": "Group 963"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2211",
    "data-name": "Path 2211",
    d: "M205.4,180.484c.034-.064.07-.127.107-.187,2.617,1.229,3.9,5.017,6.882,5.485a3.137,3.137,0,0,1,3.259,2.135l-.112.264A3,3,0,0,0,212.357,186C209.292,185.536,208.04,181.754,205.4,180.484Z",
    transform: "translate(-205.396 -180.296)",
    fill: "#70801d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_966",
    "data-name": "Group 966",
    transform: "translate(6.099 0.699)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_965",
    "data-name": "Group 965"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2212",
    "data-name": "Path 2212",
    d: "M210.443,178.614c.834,1.155,1.491,2.579,3.117,2.675l.308.265A3.775,3.775,0,0,1,210.443,178.614Z",
    transform: "translate(-210.443 -178.614)",
    fill: "#70801d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_970",
    "data-name": "Group 970",
    transform: "translate(0 4.79)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_967",
    "data-name": "Group 967",
    transform: "translate(1.041)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2213",
    "data-name": "Path 2213",
    d: "M204.144,183.736c.014-.073.03-.144.047-.213a3.188,3.188,0,0,1,1.818,1.493c1.964,3.474,6.918,1.211,8.815,4.811l-.175.118c-1.926-3.53-6.866-1.267-8.807-4.8A2.983,2.983,0,0,0,204.144,183.736Z",
    transform: "translate(-204.144 -183.523)",
    fill: "#70801d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_968",
    "data-name": "Group 968",
    transform: "translate(0.008 0.141)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2214",
    "data-name": "Path 2214",
    d: "M202.858,183.945c0-.01.038-.243.038-.253C202.883,183.778,202.871,183.863,202.858,183.945Z",
    transform: "translate(-202.858 -183.692)",
    fill: "#70801d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_969",
    "data-name": "Group 969",
    transform: "translate(0 0.394)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2215",
    "data-name": "Path 2215",
    d: "M202.848,184.044c0-.005.007-.043.008-.048l0,.046Z",
    transform: "translate(-202.848 -183.996)",
    fill: "#70801d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_972",
    "data-name": "Group 972",
    transform: "translate(0.843 7.542)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_971",
    "data-name": "Group 971"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2216",
    "data-name": "Path 2216",
    d: "M203.909,187.053c0-.077-.008-.152-.011-.229.989.239,1.444,1.2,2.3,1.623,1.681.462,3.193.323,4.623,1.863l-.344-.023c-1.358-1.382-2.8-1.149-4.367-1.642C205.267,188.242,204.833,187.326,203.909,187.053Z",
    transform: "translate(-203.898 -186.824)",
    fill: "#70801d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_974",
    "data-name": "Group 974",
    transform: "translate(1.132 9.616)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_973",
    "data-name": "Group 973"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2217",
    "data-name": "Path 2217",
    d: "M204.308,189.545c-.018-.068-.033-.139-.05-.214a3.315,3.315,0,0,1,2.8,1.137l-.309-.019A3.1,3.1,0,0,0,204.308,189.545Z",
    transform: "translate(-204.258 -189.314)",
    fill: "#70801d"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_976",
    "data-name": "Group 976",
    transform: "translate(0.081)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2218",
    "data-name": "Path 2218",
    d: "M203.458,188.059c-1.743-3.935-.231-9.464,3.1-11.879l.81.7c-3.29,2.364-4.561,7.434-3.141,11.236C203.972,188.094,203.713,188.078,203.458,188.059Z",
    transform: "translate(-202.727 -176.18)",
    fill: "#70801d"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2223",
    "data-name": "Path 2223",
    d: "M162.163,167.165l13.421,1.376-.994-7.395-2.651,4.815Z",
    transform: "translate(0 6.103)",
    fill: "#d47200"
  }))))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "Group_189",
    "data-name": "Group 189",
    transform: "translate(1084.814 4334.459)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_565",
    "data-name": "Path 565",
    d: "M1312.629,842.425c.626,15.3,13.121,27.219,27.908,26.614s26.265-13.5,25.639-28.8Z",
    transform: "translate(-1312.57 -802.861)",
    fill: "#ffbe00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_566",
    "data-name": "Path 566",
    d: "M1372.267,859.131s-6.953,3.044-25.522,3.683-25.79-1.276-25.79-1.276",
    transform: "translate(-1319.21 -817.93)",
    fill: "none",
    stroke: "#402a45",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_567",
    "data-name": "Path 567",
    d: "M1312.339,834.4c.027.66,2.05,1.185,5.444,1.534,1.823.19,4.04.329,6.556.409,1.959.064,4.1.094,6.373.083,2.688-.009,5.568-.074,8.559-.2,4.059-.166,7.9-.421,11.344-.742,9.112-.84,15.39-2.108,15.342-3.28-.049-1.208-6.773-1.97-16.337-2.027-2.889-.019-6.041.028-9.343.15-.412.01-.826.027-1.245.044-.379.015-.757.031-1.133.053-1.871.083-3.692.187-5.441.307-1.3.089-2.557.183-3.77.288a97.4,97.4,0,0,0-13.189,1.851C1313.465,833.377,1312.318,833.9,1312.339,834.4Z",
    transform: "translate(-1312.339 -794.842)",
    fill: "#402a45"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_181",
    "data-name": "Group 181",
    transform: "translate(12.792 20.443)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_180",
    "data-name": "Group 180"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_568",
    "data-name": "Path 568",
    d: "M1383.731,798.486c7.74.422,11.277-5.515,10.6-9.724a4.882,4.882,0,0,0-1.4-2.809c-3.641-3.465-8.358.312-8.358.312a11.213,11.213,0,0,0-4.59-1.212C1372.484,785.033,1374.852,798,1383.731,798.486Z",
    transform: "translate(-1375.504 -778.849)",
    fill: "#eb551f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_569",
    "data-name": "Path 569",
    d: "M1420.292,764.05s-.048-5.133,3.068-7.416",
    transform: "translate(-1411.221 -756.634)",
    fill: "none",
    stroke: "#402a45",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_570",
    "data-name": "Path 570",
    d: "M1399.659,758.416s4.107.224,4.116,5.448A4.879,4.879,0,0,1,1399.659,758.416Z",
    transform: "translate(-1394.745 -758.055)",
    fill: "#4b9f8a"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_571",
    "data-name": "Path 571",
    d: "M1397.63,785.053c.4,3.306,4.191,5.784,8.7,5.6a10.2,10.2,0,0,0,5.648-1.89,4.884,4.884,0,0,0-1.4-2.809c-3.641-3.465-8.358.312-8.358.312A11.214,11.214,0,0,0,1397.63,785.053Z",
    transform: "translate(-1393.149 -778.849)",
    fill: "#ff5c22"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_187",
    "data-name": "Group 187",
    transform: "translate(21.372 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_186",
    "data-name": "Group 186",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_185",
    "data-name": "Group 185",
    transform: "translate(9.924 6.541)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_184",
    "data-name": "Group 184"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_183",
    "data-name": "Group 183"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_182",
    "data-name": "Group 182"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_572",
    "data-name": "Path 572",
    d: "M1532.795,734.578a2.979,2.979,0,0,1,.573,4.525c-1.852,2.074-4.844,5.159-6.067,4.935C1525.736,743.751,1528.765,731.986,1532.795,734.578Z",
    transform: "translate(-1514.727 -724.845)",
    fill: "#4b9f8a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_573",
    "data-name": "Path 573",
    d: "M1468.032,743.435a2.979,2.979,0,0,0-.2,4.556c2.016,1.916,5.249,4.746,6.45,4.423C1475.816,752,1471.837,740.522,1468.032,743.435Z",
    transform: "translate(-1466.868 -731.829)",
    fill: "#4b9f8a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_574",
    "data-name": "Path 574",
    d: "M1491.628,694.036s2.747,8.473.254,9.531-9.523-12.868-5.227-15.337C1489.553,686.564,1491.628,694.036,1491.628,694.036Z",
    transform: "translate(-1481.563 -687.987)",
    fill: "#4b9f8a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_575",
    "data-name": "Path 575",
    d: "M1504.113,722.973s5.1,10.68,1.6,17.966",
    transform: "translate(-1496.57 -715.888)",
    fill: "none",
    stroke: "#3b7d6c",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_576",
    "data-name": "Path 576",
    d: "M1479.149,758.548s8.372,5.409,4.87,12.7",
    transform: "translate(-1476.662 -744.258)",
    fill: "none",
    stroke: "#3b7d6c",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_577",
    "data-name": "Path 577",
    d: "M1523.195,758.314a18.756,18.756,0,0,0-6.018,10.658",
    transform: "translate(-1506.988 -744.071)",
    fill: "none",
    stroke: "#3b7d6c",
    strokeLinecap: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_578",
    "data-name": "Path 578",
    d: "M1470.742,826.664c2.763-2.162,6.831-10.1,6.831-10.1s5.29-11.69,2.313-14.392a4.744,4.744,0,0,0-3.735-1.363c-3.068.425-6.594,4.9-7.809,20.421C1467.876,827.169,1469.072,827.971,1470.742,826.664Z",
    transform: "translate(-1467.963 -777.931)",
    fill: "#f7845b"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_579",
    "data-name": "Path 579",
    d: "M1470.742,826.8c-1.965-10.515,3.541-22.268,5.408-25.858-3.068.425-6.594,4.9-7.809,20.421C1467.876,827.3,1469.072,828.1,1470.742,826.8Z",
    transform: "translate(-1467.963 -778.063)",
    fill: "#f2754e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_580",
    "data-name": "Path 580",
    d: "M1501.613,815.122a11.705,11.705,0,0,0-5.7-1.733",
    transform: "translate(-1490.035 -787.992)",
    fill: "none",
    stroke: "#402a45",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_581",
    "data-name": "Path 581",
    d: "M1510.221,845.8a11.549,11.549,0,0,0-2.6-.742",
    transform: "translate(-1499.367 -813.248)",
    fill: "none",
    stroke: "#402a45",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_582",
    "data-name": "Path 582",
    d: "M1478.489,851.914a8.443,8.443,0,0,1,3.8,1.076",
    transform: "translate(-1476.136 -818.715)",
    fill: "none",
    stroke: "#402a45",
    strokeLinecap: "round",
    strokeWidth: 2
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_584",
    "data-name": "Path 584",
    d: "M1320.119,795.042a22.36,22.36,0,0,0,2.284,3.06c1.823.19,4.04.329,6.556.409,1.959.064,4.1.094,6.372.083a25.758,25.758,0,0,0,2.048-5.341s-.107-.126-.3-.351c-1.393-1.575-7.37-8.021-13.886-10.132a.732.732,0,0,0-.951.624l-.375,3.709L1319,785.515a.481.481,0,0,0-.707.34A13.992,13.992,0,0,0,1320.119,795.042Z",
    transform: "translate(-1316.959 -757.005)",
    fill: "#c7c5e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_585",
    "data-name": "Path 585",
    d: "M1358.794,801.738c.02.483.3.864.619.851s.567-.416.547-.9-.3-.864-.619-.851S1358.774,801.254,1358.794,801.738Z",
    transform: "translate(-1349.385 -771.443)",
    fill: "#402a45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_586",
    "data-name": "Path 586",
    d: "M1341.415,803.454s-.525,8.59-9.768,8.774",
    transform: "translate(-1327.737 -773.529)",
    fill: "none",
    stroke: "#402a45",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_188",
    "data-name": "Group 188",
    transform: "translate(12.001 30.28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_587",
    "data-name": "Path 587",
    d: "M1371.595,816.431c4.275.138,9.412.109,14.929-.116,4.06-.166,7.905-.422,11.345-.74a37.1,37.1,0,0,0-.994-5.31c-1.321-4.754-4.01-8.553-9.346.15q-.491.807-1.018,1.759a18.721,18.721,0,0,0-1.358-1.661c-1.95-2.152-5.712-5.439-9.339-3.77,0,0-1.953,1.08.128,4.368a14.433,14.433,0,0,0,1.418,1.847S1373.036,813.448,1371.595,816.431Z",
    transform: "translate(-1371.595 -805.204)",
    fill: "#4b9f8a"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_7",
    "data-name": "Line 7",
    x1: 2.75,
    y2: 5.897,
    transform: "translate(17.321 3.624)",
    fill: "none",
    stroke: "#3b7d6c",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_588",
    "data-name": "Path 588",
    d: "M1406.12,828.462a13.185,13.185,0,0,1,6.88,5.411",
    transform: "translate(-1399.128 -823.752)",
    fill: "none",
    stroke: "#3b7d6c",
    strokeLinecap: "round",
    strokeWidth: 2
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2220",
    "data-name": "Path 2220",
    d: "M1122.061,4308.186l-3.08,1.96s2.2,12.451,11.48,20.521c12.839-13.354,16.306-24.1,22.176-33.745.652-1.3,1.306-2.241,1.646-6.866s-.2-7.8,0-12.295c.35-7.771,1.874-9.822.824-13.182s-2.733-3.437-4.483-3.437-2.063,3.678-2.483,7.038.51,3.441.8,6.4,6.09,7.458,1.68,19.6-12.181,25.47-19.322,28.971S1122.061,4308.186,1122.061,4308.186Z",
    transform: "translate(0 5.652)",
    fill: "#e98b4a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2221",
    "data-name": "Path 2221",
    d: "M1200.794,4342.874s25.847,12.081,23.969-6.561c1.113,3.729,2.2,8.53,1.085,12.457-.768,1.795-3.393,3.545-7.5,3.217-1.071-.5-1.386-.705-2.627-1.3C1206.169,4346.133,1200.794,4342.874,1200.794,4342.874Z",
    transform: "translate(0 7.32)",
    fill: "#e98b4a"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2222",
    "data-name": "Path 2222",
    d: "M1209.468,4347.694c3.258.982,4.552,2.156,7.067,3.258,2.073.916,6.389-1.554,9.625-3.258-.075,8.953-5.625,15.977-9.909,15.753-1.906-.912-2.5.268-4.686-5.311A36.118,36.118,0,0,1,1209.468,4347.694Z",
    transform: "translate(0 8.931)",
    fill: "#d47200"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlan3);
export default __webpack_public_path__ + "static/media/plan3.173be108ff97a1851323d863fa9c2a4c.svg";
export { ForwardRef as ReactComponent };